import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchSpecificCampaign from 'queries/fetch/fetchSpecificCampaign.ts';
import useCampaignLock from 'hooks/useCampaignLock';
import useProtectRoute from 'hooks/useProtectRoute.ts';
import { ICampaignLevelParams } from 'utils/parameterUtils';
import featureFlags from 'services/featureFlags';
import useFetchTeamRoutingPlans from 'queries/fetch/fetchTeamRoutingPlans';
import ProgressIndicator from 'components/ProgressIndicator/index.tsx';
import useFetchTemplateForCampaign from 'queries/fetch/fetchTemplateForCampaign.ts';
import RoutingPlansForm from 'components/RoutingPlan/RoutingPlansForm';

export function RoutingPlans() {
  const { teamId, campaignId } = useParams() as ICampaignLevelParams;
  const navigate = useNavigate();
  const { data: campaign, isLoading: campaignIsLoading } = useFetchSpecificCampaign({ teamId, campaignId });
  const { lockCampaignIfRequired, error: lockError } = useCampaignLock({ teamId, campaignId });
  useProtectRoute();
  const initialRenderRef = useRef(true);
  const campaignTemplate = useFetchTemplateForCampaign({
    teamId,
    campaignId,
    isEnabled: Boolean(campaign?.CampaignConfig.Template),
  });
  const { data: teamRoutingPlans } = useFetchTeamRoutingPlans({ teamId, enabled: featureFlags.notifyRoutingPlansEnabled });

  useEffect(() => {
    if (!campaignIsLoading && initialRenderRef.current) {
      initialRenderRef.current = false;
      lockCampaignIfRequired();
    }
  }, [lockCampaignIfRequired, campaignIsLoading]);

  if (campaignIsLoading || !campaign) {
    return <ProgressIndicator text="Loading campaign..." />;
  }

  if (featureFlags.notifyRoutingPlansEnabled && !teamRoutingPlans) {
    return <ProgressIndicator text="Loading message plans..." />;
  }

  if (campaignTemplate.data?.['CampaignConfig.AvailableRoutingIds.input.display'] === 'hidden') {
    navigate(`/${teamId}/campaign/${campaign.CampaignConfig.ID}/summary`);
    return null;
  }

  return (
    <RoutingPlansForm
      campaign={campaign}
      teamId={teamId}
      campaignTemplate={campaignTemplate.data}
      teamRoutingPlans={teamRoutingPlans}
      lockError={lockError}
    />
  );
}

export default RoutingPlans;
